module.exports = __webpack_public_path__ + "media/images/icon-guest-71f7904215b756782c339b5e424cc273.svg";